import { PublicClientApplication } from "@azure/msal-browser";
import axios, { AxiosInstance } from "axios";

export const pbsLiveClientInstance: AxiosInstance = axios.create({
  baseURL: "https://pbslivecs.teampbs.com/",
  timeout: 120000,
});


export const initializePbsLiveService = (msalApp: PublicClientApplication) => {
  pbsLiveClientInstance.interceptors.request.use(async function (config) {

    config.headers.Authorization = `Bearer ${process.env.REACT_APP_PBSLIVE_API_KEY}`;
    return config;

  });

  pbsLiveClientInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response?.status === 401) {
        console.warn("Received 401 Unauthorized response from PbsLive service. Deferring to app-level authentication.");
      }
      return Promise.reject(error);
    }
  );
};
